import { Link } from "react-router-dom";

const TODAY = new Date().toLocaleDateString("en-AU", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

const SECTIONS = [
  {
    h: "Research use only",
    p: [
      "All products supplied by RegenX Wellness are intended exclusively for in-vitro laboratory research and scientific experimentation. They are not approved as therapeutic goods, drugs, food, cosmetics, or household chemicals. They are not for human or veterinary administration, consumption, diagnostic use, or therapeutic application.",
      "By placing an order, you warrant that you are a qualified researcher and that you accept full responsibility for handling, storage, and disposal of the products in accordance with all applicable laws and regulations in your jurisdiction.",
    ],
  },
  {
    h: "Eligibility",
    p: [
      "You must be at least 18 years of age to purchase from this site. By placing an order, you confirm you are 18 years or older.",
    ],
  },
  {
    h: "Order acceptance & pricing",
    p: [
      "All orders are subject to acceptance and product availability. We reserve the right to refuse or cancel any order at our sole discretion. Prices are displayed in Australian Dollars (AUD) unless otherwise noted and may change without notice. We make every effort to ensure pricing accuracy; however, in the event of a pricing error we reserve the right to cancel the order and refund any payment in full.",
    ],
  },
  {
    h: "Payment",
    p: [
      "We accept credit and debit cards via Stripe and direct bank transfer (ACH/wire). For bank transfers, your order is held pending receipt of cleared funds; please reference your order ID in the payment.",
    ],
  },
  {
    h: "Returns & refunds",
    p: [
      "Due to the nature of research-grade peptides, we are unable to accept returns on products that have left our facility, except where the product is demonstrably defective or shipped in error. If you believe your order is incorrect or damaged, contact us within 7 days of delivery with photographic evidence and we will work with you on a replacement, credit, or refund.",
    ],
  },
  {
    h: "Limitation of liability",
    p: [
      "To the maximum extent permitted by law, RegenX Wellness shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with the use of the products. The total liability of RegenX Wellness for any claim shall not exceed the amount paid by you for the product giving rise to the claim.",
      "Nothing in these terms is intended to exclude or limit any guarantees that cannot be excluded under the Australian Consumer Law.",
    ],
  },
  {
    h: "Governing law",
    p: [
      "These terms are governed by the laws of Victoria, Australia. Any dispute arising under or in connection with these terms will be subject to the exclusive jurisdiction of the courts of Victoria, Australia.",
    ],
  },
  {
    h: "Contact",
    p: [
      "Questions about these terms can be directed to info@regenxwellness.com.au.",
    ],
  },
];

export default function Terms() {
  return (
    <div data-testid="terms-page" className="animate-in fade-in duration-500">
      <section className="px-6 md:px-12 lg:px-24 pt-20 pb-12 border-b border-border max-w-4xl">
        <p className="overline text-primary mb-5">Legal</p>
        <h1 className="editorial-heading text-5xl md:text-6xl text-secondary leading-[0.95] mb-6">
          Terms &amp; conditions
        </h1>
        <p className="text-sm text-muted-foreground">Last updated: {TODAY}</p>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-16 max-w-4xl space-y-12">
        {SECTIONS.map((s, i) => (
          <div key={i} data-testid={`terms-section-${i}`}>
            <h2 className="editorial-heading text-2xl md:text-3xl text-secondary mb-4">
              {s.h}
            </h2>
            {s.p.map((para, j) => (
              <p key={j} className="text-base text-muted-foreground leading-relaxed mb-4">
                {para}
              </p>
            ))}
          </div>
        ))}
        <div className="pt-8 border-t border-border">
          <Link
            to="/"
            className="text-xs uppercase tracking-[0.22em] text-secondary hover:text-primary border-b border-secondary pb-1"
            data-testid="terms-back-home"
          >
            ← Back home
          </Link>
        </div>
      </section>
    </div>
  );
}
